// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"9bfdd7c2","224":"0a9c1817"}[chunkId] + ".chunk.css";
};